import { readonly, ref } from 'vue'

const myTenantRef = ref(null)
const myTenantIdRef = ref(null)
const myTenantNameRef = ref(null)
const myTenantRecursiveRef = ref(true)

// Set the global tenant; this is expected to be a structured segment object with a name, a display name, and an ID.
export function setGlobalTenant(tenant) {
	myTenantRef.value = tenant
	if (myTenantRef.value) {
		myTenantIdRef.value = myTenantRef.value.id

		var name = myTenantRef.value.name
		if (myTenantRef.value.displayName && myTenantRef.value.displayName != '') {
			name = myTenantRef.value.displayName
		}
		myTenantNameRef.value = name
	}
}

// Set the global tenant recursion; this is true for including all children of the tenant in the global tenant.
export function setGlobalTenantRecursive(recursive) {
	myTenantRecursiveRef.value = recursive
}

export function globalTenantRef() {
	return readonly(myTenantRef)
}
export function globalTenantIdRef() {
	return readonly(myTenantIdRef)
}
export function globalTenantNameRef() {
	return readonly(myTenantNameRef)
}

export function globalTenantRecursiveRef() {
	return readonly(myTenantRecursiveRef)
}
